import * as React from "react";
import tw, { styled } from "twin.macro";

import { ReactComponent as InfoIcon } from "app/assets/icons/verification-link-expired.svg";
import { ReactComponent as ErrorIcon } from "app/assets/icons/error-2.svg";
import Text from "app/styles/Text";
import SubHeader from "app/styles/SubHeader";
import { useAppState } from "app/providers/AppStateProvider";

const iconStyles = tw`mx-auto`;
const icons = {
  info: <InfoIcon css={iconStyles} />,
  warning: <ErrorIcon css={iconStyles} />,
};

interface Props extends React.BaseHTMLAttributes<HTMLDivElement> {
  status: "info" | "warning";
  description: React.ReactNode;
  title: string;
}
export default function StatusView(props: React.PropsWithChildren<Props>) {
  const { status, children, title, description, ...rest } = props;
  const { displayMode } = useAppState();

  return (
    <Container {...rest} $isInline={displayMode === "INLINE"}>
      {icons[status]}

      <SubHeader semiBold tw="mb-[2px] mt-[24px] text-[24px]">
        {title}
      </SubHeader>

      {typeof description === "string" ? (
        <Text small subdued mediumBold>
          {description}
        </Text>
      ) : (
        description
      )}

      {children}
    </Container>
  );
}

const Container = styled.div<{ $isInline?: boolean }>`
  ${tw`max-w-[526px] w-full bg-containment-tertiary rounded-[24px] text-center py-[40px] px-[16px] mobile:px-[16px]`};

  ${({ $isInline }) => $isInline && tw`max-w-[500px]`};
`;
